module.exports = __webpack_public_path__ + "static/media/MaxBounty_Horizontal_White.05a41ba0.png";